import Data from 'data';
import { deepCopy } from 'utils';
import { formatNumber } from 'utils/format';
import { calcFrames, processInfo } from 'logic/skills';

export const skills = {
  poisondart: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "psn", coeff: 1.85}, "Dot Damage": {elem: "psn", coeff: 0.4, total: true}}; break;
      case "b": res = {"Damage": {elem: "psn", coeff: 1.1}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 1.85}, "Dot Damage": {elem: "col", coeff: 0.4, total: true}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 1.85}, "Dot Damage": {elem: "phy", coeff: 0.4, total: true}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 5.65, total: true}}; break;
      case "e": res = {"Damage": {elem: "psn", coeff: 1.85}, "Dot Damage": {elem: "psn", coeff: 0.4, total: true}}; break;
      default: return;
      }
      const dps = {sum: true, "Damage": {speed: 1, fpa: 58, round: "up", count: (rune === "b" ? 3 : 1)}};
      if (res["Dot Damage"]) dps["Dot Damage"] = 1;

      if ((stats.leg_carnevil || stats.leg_carnevil_p65) && (stats.skills.fetisharmy || stats.passives.fetishsycophants || stats.leg_beltoftranscendence)) {
        if (stats.skills.fetisharmy || stats.passives.fetishsycophants || stats.leg_beltoftranscendence) {
          const damage = {elem: "psn", pet: true, aps: true, coeff: 1.3, percent: {[Data.itemById.Unique_VoodooMask_101_x1.name]: 250}};
          let count = 0;
          if (stats.skills.fetisharmy) {
            count += (({x: 5, a: 5, d: 5, b: 8, c: 7, e: 7})[stats.skills.fetisharmy] || 0);
          }
          if (stats.passives.fetishsycophants || stats.leg_beltoftranscendence) {
            count += Data.passives.witchdoctor.fetishsycophants.params[0].val;
          }
          count = Math.min(count, stats.leg_carnevil_p65 ? 10 : 10);
          res["Fetish Damage"] = deepCopy({percent: {"Army %": stats.skill_witchdoctor_fetisharmy}}, damage);
          dps["Fetish Damage"] = {speed: 1, fpa: 58, round: "up", nobp: true, count: count, factor: 2};
        }
        res["Total DPS"] = dps;
      } else {
        res["DPS"] = dps;
      }
      return res;
    },
  },
  corpsespiders: {
    params: [
      {min: 0, max(stats) {
        const fpa = calcFrames(stats, 58, null, null, 1, "up");
        return Math.round(300 / fpa * 12 * (1 + 0.01 * (stats.leg_taskerandtheo || 0)));
      }, name: "Stacks", buffs: false, show(rune, stats) {
        return !!stats.leg_broodofaraneae;
      }},
    ],
    info(rune, stats) {
      const res = {
        "Damage": {elem: Data.skilltips.witchdoctor.corpsespiders.elements[rune], coeff: 5.76, total: true, pet: true},
        "DPS": {sum: true, "Damage": {speed: 1, fpa: 58, round: "up"}},
      };
      if (rune === "c") res["Damage"].coeff = 6.45;
      if (rune === "b") { res["Damage"].coeff = 26.25; res["DPS"]["Damage"] = {factor: 1 / 15}; }
      if (rune === "d") res["Damage"].coeff = 7;
      if (stats.leg_broodofaraneae && this.params[0].val) {
        res["Damage"].percent = {[Data.itemById.P72_Unique_Belt_007.name]: this.params[0].val};
      }
      return res;
    },
  },
  plagueoftoads: {
    info: {
      "*": {"DPS": {sum: true, "Damage": {speed: 1, count: 4, fpa: 57.5, round: "up"}}},
      x: {"Damage": {elem: "psn", coeff: 1.9}},
      a: {"Damage": {elem: "fir", coeff: 2.45}},
      c: {"Damage": {elem: "phy", coeff: 1.3}},
      b: {"Damage": {elem: "psn", coeff: 1.3, total: true}, "DPS": {sum: true, "Damage": {speed: 1.4, fpa: 55.384609, round: "up"}}},
      e: {"Damage": {elem: "psn", coeff: 1.9}},
      d: {"Damage": {elem: "col", coeff: 1.9}},
    },
  },
  firebomb: {
    info: {
      "*": {"DPS": {sum: true, "Damage": {speed: 1, fpa: 58, round: "up"}}},
      x: {"Damage": {elem: "fir", coeff: 1.55}},
      e: {"Damage": {elem: "fir", coeff: 1.55}},
      b: {"Damage": {elem: "fir", coeff: 1.55}},
      c: {"Damage": {elem: "fir", coeff: 1.55}, "Pool Damage": {elem: "fir", coeff: 0.6, total: true}},
      d: {"Damage": {elem: "fir", coeff: 8.8, total: true}, "DPS": {sum: true, "Damage": {factor: 3, divide: 6}}},
      a: {"Damage": {elem: "fir", coeff: 1.55}, "Blast Damage": {elem: "col", coeff: 0.3}},
    },
  },
  graspofthedead: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 7.6, total: true}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 5.6, total: true}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 13.6, total: true}}; break;
      case "e": res = {"Damage": {elem: "psn", coeff: 5.6, total: true}}; break;
      case "d": res = {"Damage": {elem: "psn", coeff: 5.6, total: true}}; break;
      case "b": res = {"Damage": {elem: "phy", coeff: 5.6, total: true}, "Corpse Damage": {elem: "phy", coeff: 4.2, total: true}}; break;
      default: return;
      }
      if (stats.leg_deadlyrebirth && rune !== "b") {
        res["Corpse Damage"] = {elem: res["Damage"].elem, coeff: 4.2, total: true};
      }
      const toex = {};
      if (rune !== "c") toex["Cost"] = {cost: 150};
      if (!stats.leg_wilkensreach) toex["Cooldown"] = {cooldown: (rune === "d" ? 4 : 8)};
      return Object.assign(toex, res);
    },
  },
  firebats: {
    range: {x: 28, a: 28, d: 28, c: 28, b: 60, e: 15},
    params: [{rune: "e", min: 0, max: 5, val: 5, step: 0.5, name: "Channeled for", buffs: false},
             {rune: "c", min: 0, max: 3, val: 3, step: 0.5, name: "Channeled for", buffs: false}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Tick Damage": {elem: "fir", coeff: 4.75, divide: {"Base Speed": 2}}}; break;
      case "a": res = {"Channeling Cost": {cost: 125, fpa: 60}, "DPS": {sum: true, "Tick Damage": {speed: 1, fpa: 60}}, "Tick Damage": {elem: "fir", coeff: 5}}; break;
      case "d": res = {"Cost": {cost: 250}, "Channeling Cost": null, "Tick Damage": {elem: "phy", coeff: 4.75, divide: {"Base Speed": 2}}}; break;
      case "c": res = {"Tick Damage": {elem: "psn", coeff: 4.75, divide: {"Base Speed": 2}, percent: {"Channeling": "$2*51.5/3"}}}; break;
      case "b": res = {"Tick Damage": {elem: "fir", coeff: 7.5, divide: {"Base Speed": 2}}}; break;
      case "e": res = {"Tick Damage": {elem: "fir", coeff: 4.25, divide: {"Base Speed": 2}, percent: {"Channeling": "$1*20"}}}; break;
      default: return;
      }
      res = Object.assign({"Cost": null, "Channeling Cost": {cost: 125, fpa: 30}, "DPS": {sum: true, "Tick Damage": {speed: 1, fpa: 30}}}, res);
      if (stats.leg_staffofchiroptera || stats.leg_staffofchiroptera_p6) {
        res["DPS"]["Tick Damage"].speed *= 2;
        const rcr = {};
        if (stats.leg_staffofchiroptera_p6) rcr.leg_staffofchiroptera_p6 = 75;
        else if (stats.leg_staffofchiroptera) rcr.leg_staffofchiroptera = stats.leg_staffofchiroptera;
        if (res["Cost"]) res["Cost"].rcr = rcr;
        if (res["Channeling Cost"]) res["Channeling Cost"].rcr = rcr;
      }
      return res;
    },
    active: true,
    buffs(rune, stats) {
      if (stats.leg_coilsofthefirstspider) {
        return {lph: stats.leg_coilsofthefirstspider, dmgred: 30};
      }
    },
  },
  haunt: {
    info(rune, stats) {
      const damage = {elem: Data.skilltips.witchdoctor.haunt.elements[rune], coeff: 40, total: true};
      let res;
      if (stats.passives.creepingdeath) {
        damage.divide = {"Base Duration": (stats.leg_quetzalcoatl ? 6 : 12)};
        res = {"DPS": damage};
      } else {
        res = {"DPS": {sum: true, "Damage": {divide: (stats.leg_quetzalcoatl ? 6 : 12)}}, "Damage": damage};
      }
      if (stats.set_jadeharvester_2pc) {
        res["Reapplication Damage"] = {elem: damage.elem, coeff: 40, divide: {"Base Duration": (stats.leg_quetzalcoatl ? 6 : 12)}, factors: {"Duration": 3500}};
        res["Spam DPS"] = {sum: true, "DPS": {}, "Reapplication Damage": {speed: 1, fpa: 57.5, round: "up"}};
      }
      return Object.assign({"Cost": {cost: 50}}, res);
    },
    active: true,
    buffs: {
      c: {dmgmul: 20},
    },
  },
  locustswarm: {
    info(rune, stats) {
      let damage;
      switch (rune) {
      case "a": damage = {elem: "fir", coeff: 14.8, total: true}; break;
      case "c": damage = {elem: "phy", coeff: 10.4, total: true}; break;
      default: damage = {elem: "psn", coeff: 10.4, total: true};
      }
      const dur = (stats.leg_quetzalcoatl ? 0.5 : 1) * 8;
      let res;
      if (stats.passives.creepingdeath) {
        damage.divide = {"Base Duration": dur};
        res = {"DPS": damage};
      } else {
        res = {"DPS": {sum: true, "Damage": {divide: dur}}, "Damage": damage};
      }
      if (rune === "e") {
        res["Cloud Damage"] = {elem: "psn", coeff: 7.5, total: true};
      }
      return Object.assign({"Cost": {cost: 300}}, res);
    },
  },
  summonzombiedogs: {
    info(rune, stats) {
      const base = {pet: true, aps: true};
      let count = 3 + (stats.passives.zombiehandler ? 1 : 0) + (stats.passives.fierceloyalty ? 1 : 0) + (stats.passives.midnightfeast ? 1 : 0);
      let lphm = 1;
      if (stats.leg_thetallmansfinger) {
        base.percent = {[Data.itemById.Unique_Ring_101_x1.name]: 800 * count};
        lphm = 8 * count + 1;
        count = 1;
      }
      const res = {"Damage": {elem: Data.skilltips.witchdoctor.summonzombiedogs.elements[rune], coeff: 1.2, ...base}};
      if (rune === 'c' || stats.seasontheme_018) res["Poison Damage"] = {elem: "psn", coeff: 1.2, total: true, ...base};
      if (rune === 'a' || stats.seasontheme_018) res["Burn DPS"] = {elem: "fir", coeff: 0.4, total: true, ...base};
      if (rune === 'e' || stats.seasontheme_018) res["Healing"] = formatNumber(stats.lph * (1 + 0.01 * (stats.petias || 0)) * lphm * count, 0, 10000);
      res["DPS"] = {sum: true, "Damage": {pet: 60, count: count}};
      if (rune === 'c' || stats.seasontheme_018) res["DPS"]["Poison Damage"] = {pet: 60, count: count};
      if (rune === 'a' || stats.seasontheme_018) res["DPS"]["Burn DPS"] = {count: count};
      return {"Cooldown": {cooldown: 45 * (stats.passives.tribalrites ? 0.75 : 1)}, ...res};
    },
    active: true,
    buffs: {
      b: {dmgred: 10},
    },
  },
  horrify: {
    info(rune, stats) {
      const cd = 10;
      const res = {};
      if (stats.leg_tiklandianvisage) {
        res["Fear Uptime"] = {cooldown: cd, duration: stats.leg_tiklandianvisage};
      }
      if (rune === "e") {
        res["Speed Uptime"] = {cooldown: cd, duration: 4};
      }
      if (rune === "a") {
        res["Armor Uptime"] = {cooldown: cd, duration: 8};
      }
      if (Object.keys(res).length) {
        return res;
      }
    },
    active: false,
    buffs(rune, stats) {
      const result = {};
      if (rune === 'a') result.armor_percent = 50;
      if (rune === 'e') result.extrams = 20;
      if (stats.seasontheme_009) result.dmgtaken = 100;
      return result;
    },
  },
  spiritwalk: {
    info: {
      "*": {"Uptime": {cooldown: 10, duration: 2, after: true}},
      b: {"Uptime": {cooldown: 10, duration: 3, after: true}},
      c: {"Damage": {elem: "fir", coeff: 7.5}},
    },
    active: false,
    buffs: {
      x: {extrams: 50},
      b: {extrams: 50},
      d: {extrams: 50},
      c: {extrams: 50},
      a: {extrams: 150},
      e: {extrams: 50},
    },
  },
  hex: {
    info(rune, stats) {
      let res = {"Uptime": {cooldown: 15 * (stats.passives.tribalrites ? 0.75 : 1), duration: 12}};
      switch (rune) {
      case "b":
        res = {"Cooldown": {cooldown: 15 * (stats.passives.tribalrites ? 0.75 : 1)}, "Explosion Damage": {elem: "psn", coeff: 13.5}};
        if (stats.set_manajuma_2pc) {
          res["Explosion Damage"].percent = {[Data.itemSets.manajuma.name]: 2000};
          res["Secondary Explosion Damage"] = {sum: true, "Explosion Damage": {factor: 0.25}};
        }
        break;
      case "a":
        return {"Cooldown": {cooldown: 15 * (stats.passives.tribalrites ? 0.75 : 1)}, "Damage": {elem: "psn", coeff: 7.5, total: true}};
      case "c":
        res["Explosion Damage"] = {elem: "fir", coeff: 5};
        break;
      // no default
      }
      return res;
    },
    active: false,
    buffs(rune, stats) {
      const res = {};
      switch (rune) {
      case "e": res.dmgtaken = 15; break;
      case "b": res.extrams = 50 + (stats.set_manajuma_2pc ? 100 : 0); break;
      case "a": res.dmgtaken = 15; break;
      // no default
      }
      return res;
    },
  },
  soulharvest: {
    info(rune, stats) {
      const res = {};
      if (rune === "e" || stats.set_jadeharvester_4pc) {
        res["Damage"] = {elem: "phy", coeff: 6.3};
      }
      if (stats.set_jadeharvester_6pc) {
        const haunt_rune = stats.skills.haunt;
        let haunt_dps, haunt_dur;
        if (haunt_rune) {
          let haunt_info = Data.skills.witchdoctor.haunt.info(haunt_rune, stats);
          haunt_dur = (stats.passives.creepingdeath ? 26000 : haunt_info["DPS"]["Damage"].divide);
          haunt_info = processInfo(haunt_info, {skill: ["haunt", haunt_rune], stats, notext: true});
          haunt_dps = haunt_info["DPS"].value;
        }

        let swarm_rune = stats.skills.locustswarm;
        if (!swarm_rune && stats.leg_wormwood) {
          swarm_rune = "x";
        }
        let swarm_dps, swarm_dur;
        if (swarm_rune) {
          let swarm_info = Data.skills.witchdoctor.locustswarm.info(swarm_rune, stats);
          swarm_dur = (stats.passives.creepingdeath ? 26000 : swarm_info["DPS"]["Damage"].divide);
          swarm_info = processInfo(swarm_info, {skill: ["locustswarm", swarm_rune], stats, notext: true});
          swarm_dps = swarm_info["DPS"].value;
        }

        if (haunt_dps || swarm_dps) {
          const jade = {sum: true};
          if (haunt_dps) {
            jade["Haunt Damage"] = {value: haunt_dps, factor: haunt_dur};
          }
          if (swarm_dps) {
            jade["Locust Swarm Damage"] = {value: swarm_dps, factor: swarm_dur};
          }
          res["Jade Harvester Damage"] = jade;
        }
      }
      return Object.assign({"Cooldown": {cooldown: 12}}, res);
    },
    active: false,
    params: [{min: 0, max: "leg_sacredharvester?10:5", name: "Stacks"}],
    buffs(rune, stats) {
      const stacks = this.params[0].val;
      const res = {int_percent: stacks * 3};
      if (stats.leg_lakumbasornament) res.dmgred = 6 * stacks;
      if (stats.leg_lakumbasornament_p72 && stacks >= stats.leg_lakumbasornament_p72) res.dmgred = 60 + 2 * stacks;
      if (rune === "d" || stats.set_jadeharvester_4pc) res.maxmana = (stacks > 5 ? 5 : stacks) * 750 * 0.05;
      if (rune === "c" || stats.set_jadeharvester_4pc) res.armor_percent = stacks * 10;
      if (rune === "b" || stats.set_jadeharvester_4pc) res.extrams = stacks * 5;
      return res;
    },
  },
  sacrifice: {
    info: {
      x: {"Damage": {elem: "phy", coeff: 10.9, percent: {"The Tall Man's Finger": "leg_thetallmansfinger?200:0"}}},
      c: {"Damage": {elem: "phy", coeff: 10.9, percent: {"The Tall Man's Finger": "leg_thetallmansfinger?200:0"}}},
      e: {"Damage": {elem: "phy", coeff: 10.9, percent: {"The Tall Man's Finger": "leg_thetallmansfinger?200:0"}}},
      d: {"Damage": {elem: "phy", coeff: 10.9, percent: {"The Tall Man's Finger": "leg_thetallmansfinger?200:0"}}},
      b: {"Damage": {elem: "phy", coeff: 13, percent: {"The Tall Man's Finger": "leg_thetallmansfinger?200:0"}}},
      a: {"Damage": {elem: "phy", coeff: 10.9, percent: {"The Tall Man's Finger": "leg_thetallmansfinger?200:0"}}},
    },
    active: false,
    params: [{rune: "a", min: 0, max: 5, val: 0, name: "Stacks"}],
    buffs(rune, stats) {
      const res = {};
      if (rune === "a") res.damage = this.params[0].val * 20;
      if (stats.seasontheme_018) res.dmgmul = {pet: true, percent: 100};
      if (Object.keys(res).length) return res;
    },
  },
  massconfusion: {
    info: {
      x: {"Uptime": {duration: 12, cooldown: "60*(passives.tribalrites?0.75:1)"}},
      d: {"Uptime": {duration: 12, cooldown: "30*(passives.tribalrites?0.75:1)"}},
      e: {"Uptime": {duration: 12, cooldown: "60*(passives.tribalrites?0.75:1)"}},
      b: {"Uptime": {duration: 12, cooldown: "60*(passives.tribalrites?0.75:1)"}},
      a: {"Uptime": {duration: 12, cooldown: "60*(passives.tribalrites?0.75:1)"}},
      c: {"DPS": {elem: "phy", coeff: 4, total: true}, "Uptime": {duration: 12, cooldown: "60*(passives.tribalrites?0.75:1)"}},
    },
    active: false,
  },
  zombiecharger: {
    info: {
      "*": {"Cost": {cost: 150, rcr: {leg_scrimshaw: "leg_scrimshaw", leg_scrimshaw_p610: "leg_scrimshaw_p610?75:0"}}},
      x: {"Damage": {elem: "psn", coeff: 5.6}},
      c: {"Damage": {elem: "phy", coeff: 8.8}},
      d: {"Damage": {elem: "psn", coeff: 5.6}, "Reanimate Damage": {elem: "psn", coeff: 4.8}},
      b: {"Damage": {elem: "col", coeff: 2.8, factors: {"Zombies": 7}}},
      e: {"Damage": {elem: "fir", coeff: 6.8}},
      a: {"Damage": {elem: "psn", coeff: 5.2, factors: {"Bears": "leg_ursuastroddeneffigy?8:3"}}},
    },
  },
  spiritbarrage: {
    params: [{min: 0, max: 3, name: "Phantasms", buffs: false, show(rune, stats) {
               return stats.leg_gazingdemise;
             }}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "col", coeff: 1.5}}; break;
      case "d": res = {"Damage": {elem: "col", coeff: 1.5}}; break;
      case "b": res = {"Damage": {elem: "fir", coeff: 1.5}, "Spirit Damage": {elem: "fir", coeff: 0.65}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 0.75, aps: true, petspecial: true}}; break;
      case "a": res = {"Damage": {elem: "col", coeff: 1.5, total: true}}; break;
      case "e": res = {"Damage": {elem: "col", coeff: 3.5}}; break;
      default: return;
      }
      if (rune === "c") {
        res["DPS"] = {sum: true, "Damage": {count: 3, pet: 30, nobp: true}};
      } else if (rune === "e") {
        res["DPS"] = {sum: true, "Damage": {fpa: 30, nobp: true}};
      } else {
        res["DPS"] = {sum: true, "Damage": {count: 4, speed: 1.2, fpa: 57.142834, round: "up"}};
        if (res["Spirit Damage"]) {
          res["DPS"]["Spirit Damage"] = {speed: 1.2, count: 3, fpa: 57.142834, round: "up", nobp: true};
        }
      }
      if ((stats.leg_gazingdemise || stats.leg_gazingdemise_p68) && rune === "e") {
        res["DPS"]["Damage"].fpa = 6;
      }
      if (stats.leg_gazingdemise && this.params[0].val) {
        const pct = {[Data.itemById.P42_Unique_Mojo_003_x1.name]: this.params[0].val * (stats.leg_gazingdemise || stats.leg_gazingdemise_p68)};
        res["Damage"].percent = pct;
        if (res["Spirit Damage"]) {
          res["Spirit Damage"].percent = pct;
        }
        if (rune !== "c") {
          res["Phantasm Damage"] = {elem: res["Damage"].elem, coeff: 0.75, aps: true, percent: pct, petspecial: true};
          res["DPS"]["Phantasm Damage"] = {count: this.params[0].val, pet: 30, nobp: true};
        }
      }
      if (stats.leg_gazingdemise_p68 && rune !== "c") {
        res["Phantasm Damage"] = {elem: res["Damage"].elem, coeff: 0.75, aps: true, petspecial: true};
        res["DPS"]["Phantasm Damage"] = {count: 3, pet: 30, nobp: true};
      }
      return Object.assign({"Cost": {cost: 100}}, res);
    },
  },
  acidcloud: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "psn", coeff: 3, addcoeff: [3.6], total: 0}}; break;
      case "b": res = {"Damage": {elem: "psn", coeff: 3, addcoeff: [3.6], total: 0}}; break;
      case "c": res = {"Damage": {elem: "psn", coeff: 3, addcoeff: [6], total: 0}}; break;
      case "d": res = {"Damage": {elem: "col", coeff: 3, addcoeff: [7.2], total: 0}}; break;
      case "e": res = {"Damage": {elem: "psn", coeff: 3.33, addcoeff: [4], total: 0}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 7}}; break;
      default: return;
      }
      if (rune !== "c" && stats.leg_suwongdiviner) {
        res["Blob Damage"] = {elem: "psn", coeff: 6, total: true};
      }
      return Object.assign({"Cost": {cost: 175}}, res);
    },
  },
  wallofdeath: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 12, total: true}}; break;
      case "b": res = {"Damage": {elem: "psn", coeff: 12, total: true}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 12, total: true}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 12.5, total: true}}; break;
      case "e": res = {"Damage": {elem: "fir", coeff: 11, total: true}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 12, total: true}}; break;
      default: return;
      }
      return Object.assign({"Cooldown": {cooldown: 8}}, res);
    },
  },
  piranhas: {
    info: {
      "*": {"Cost": {cost: 250}, "Cooldown": {cooldown: 8}},
      x: {"Damage": {elem: "psn", coeff: 4, total: true}},
      a: {"Damage": {elem: "phy", coeff: 4, total: true}, "Bogadile Damage": {elem: "phy", coeff: 11}},
      b: {"Damage": {elem: "psn", coeff: 4, total: true}},
      c: {"Damage": {elem: "psn", coeff: 2, total: true}},
      d: {"Damage": {elem: "psn", coeff: 4.75, total: true}},
      e: {"Damage": {elem: "col", coeff: 4, total: true}},
    },
    active: false,
    buffs: {
      x: {dmgtaken: 15},
      a: {dmgtaken: 15},
      b: {dmgtaken: 15},
      c: {dmgtaken: 15},
      d: {dmgtaken: 15},
      e: {dmgtaken: 15},
    },
  },
  gargantuan: {
    active: true,
    activetip: "Enraged",
    activeshow(rune, stats) {
      return rune === 'a' || stats.seasontheme_018;
    },
    info(rune, stats) {
      let count = 1;
      const base = {pet: true, aps: true};
      if (stats.leg_theshortmansfinger || stats.leg_theshortmansfinger_p6) count = 3;
      const res = {"Damage": {elem: Data.skilltips.witchdoctor.gargantuan.elements[rune], coeff: 4.5, ...base}};
      if (rune === 'b') res["Damage"].coeff = 5.85;
      if (rune === 'd') res["Damage"].coeff = 5.75;
      if (rune === 'c') res["Poison DPS"] = {elem: "psn", coeff: 1.35, total: true, ...base};
      if (rune === 'e') res["Slam Damage"] = {elem: "fir", coeff: 2, ...base};
      res["DPS"] = {sum: true, "Damage": {pet: 84, count: count}};
      if ((rune === 'a' || stats.seasontheme_018) && this.active) {
        res["Damage"].percent = {"Enrage": 200};
        res["DPS"]["Damage"].ias = 35;
      }
      if (rune === "c") res["DPS"]["Poison DPS"] = {count: count};
      return {"Cooldown": {cooldown: 60 * (stats.passives.tribalrites ? 0.75 : 1)}, ...res};
    },
  },
  bigbadvoodoo: {
    info(rune, stats) {
      if (!stats.leg_starmetalkukri) {
        return {"Uptime": {duration: (rune === "b" ? 30 : 20) * (stats.set_mundunugu_2pc ? 2 : 1), cooldown: 120 * (stats.passives.tribalrites ? 0.75 : 1)}};
      }
    },
    active: false,
    buffs: {
      x: {ias: 15, extrams: 15},
      b: {ias: 15, extrams: 15},
      d: {ias: 15, extrams: 15, manaregen: 250},
      a: {ias: 15, extrams: 15, damage: 15},
      c: {ias: 15, extrams: 15, dmgred: 20},
      e: {ias: 15, extrams: 15},
    },
  },
  fetisharmy: {
    info(rune, stats) {
      const elem = Data.skilltips.witchdoctor.fetisharmy.elements[rune];
      const data = {"Cooldown": {cooldown: (rune === "d" ? 90 : 120)}, "Dagger Damage": {elem: elem, pet: true, aps: true, coeff: 1.8}};
      if (stats.passives.tribalrites) data["Cooldown"].cooldown *= 0.75;
      if (stats.set_zunimassa_2pc) data["Cooldown"].cooldown *= 0.2;
      let count = 5;
      switch (rune) {
      case "a": data["Explosion Damage"] = {elem: "col", coeff: 6.8}; break;
      case "b": count = 8; break;
      case "c": data["Torcher Damage"] = {elem: "fir", pet: true, aps: true, coeff: 0.85}; break;
      case "e": data["Dart Damage"] = {elem: "psn", pet: true, aps: true, coeff: 1.3}; break;
      // no default
      }
      data["Total DPS"] = {sum: true, "Dagger Damage": {pet: 48, count: count}};
      if (rune === "c") data["Total DPS"]["Torcher Damage"] = {pet: 42, count: 2};
      if (rune === "e") data["Total DPS"]["Dart Damage"] = {pet: 42, count: 2};
      return data;
    },
  },
};

export const passives = {
  junglefortitude: {
    buffs: {dmgred: 15},
  },
  circleoflife: {
  },
  spiritualattunement: {
    buffs: {maxmana_percent: 10, manaregen_percent: 2},
  },
  gruesomefeast: {
    params: [{min: 0, max: 5, val: 0, name: "Stacks"}],
    buffs(stats) {
      return {int_percent: this.params[0].val * 10};
    },
  },
  bloodritual: {
    buffs: {rcr: 20, regen_percent: 1},
  },
  badmedicine: {
  },
  zombiehandler: {
    buffs: {life: 20},
  },
  piercetheveil: {
    buffs: {damage: 20, rcr: -30},
  },
  spiritvessel: {
  },
  fetishsycophants: {
    params: [{min: 0, max: 15, name: "Count", buffs: false, show(stats) {
      return !!this.id || !stats.passives.fetishsycophants;
    }}],
    info(stats) {
      return {
        "Fetish Damage": {elem: "max", pet: true, aps: true, coeff: 1.8, skill: "fetisharmy"},
        "Fetish DPS": {sum: true, "Fetish Damage": {pet: 48}},
        "Total DPS": {sum: true, "Fetish DPS": {count: this.params[0].val}},
      };
    },
  },
  rushofessence: {
  },
  visionquest: {
    active: true,
    buffs: {resourcegen: 40},
  },
  fierceloyalty: {
    buffs: {extrams: 15},
  },
  graveinjustice: {
  },
  tribalrites: {
  },
  confidenceritual: {
    active: true,
    buffs: {dmgmul: 25},
  },
  creepingdeath: {
  },
  swamplandattunement: {
    params: [{min: 0, max: 25, val: 0, name: "Nearby Enemies"}],
    buffs(stats) {
      return {
        resphy: 120 * this.params[0].val,
        respsn: 120 * this.params[0].val,
        resfir: 120 * this.params[0].val,
        rescol: 120 * this.params[0].val,
      };
    },
  },
  midnightfeast: {
    buffs: {dmgmul: {skills: ["summonzombiedogs", "gargantuan"], percent: 50}},
  },
};

export const partybuffs = {
  summonzombiedogs: { // ptr
    runelist: "d",
  },
  hex: {
    runelist: "ae",
  },
  piranhas: {
    runelist: "x",
    buffs(stats) {
      return {dmgtaken: 15};
    },
  },
  bigbadvoodoo: {
    runelist: "*",
  },
};

export const extraskills = {
  hex_explode: {
    required(stats) {
      return stats.skills.hex === "b";
    },
  },
};
